// import axios from "axios";

// const api = axios.create({
//   // baseURL: "http://10.202.100.90:9024/api",//local
//   // baseURL: "https://2rksqptn-9018.inc1.devtunnels.ms//api",//UAT
//   // baseURL: "https://k3ndpxhp-9014.inc1.devtunnels.ms/api",//Port forwarding 
//    baseURL: "https://mahatransco.org/api",//Prodcution  
//   timeout: 30000,
// });

// api.interceptors.request.use(
//   (config) => {
//     const token =
//       localStorage.getItem("access");

//     if (token) {
//       config.headers.Authorization =
//         `Bearer ${token}`;
//     }

//     return config;
//   },
//   (error) => Promise.reject(error)
// );

// api.interceptors.response.use(
//   (response) => response,

//   (error) => {
//     if (
//       error.response?.status === 401
//     ) {
//       localStorage.clear();
//     }

//     return Promise.reject(error);
//   }
// );

// export default api;


// import axios from "axios";
// import { toast } from "react-toastify";

// const api = axios.create({
//   baseURL: "https://mahatransco.org/api",
//   timeout: 30000,
// });

// api.interceptors.request.use(
//   (config) => {
//     const token = localStorage.getItem("access");
//     if (token) {
//       config.headers.Authorization = `Bearer ${token}`;
//     }
//     return config;
//   },
//   (error) => Promise.reject(error)
// );

// api.interceptors.response.use(
//   (response) => response,

//   (error) => {
//     if (error.response?.status === 401) {
//       localStorage.setItem("lastAuthError", "401"); // flag for toast
//       localStorage.clear();

//       // Optional: show toast immediately from interceptor
//       toast.error("Session expired. Please login again.", {
//         position: "top-right",
//         autoClose: 4000,
//       });

//       // Force redirect to login (works even if inside a component)
//       setTimeout(() => {
//         window.location.href = "/"; // or use navigate if you prefer
//       }, 500);
//     }

//     return Promise.reject(error);
//   }
// );

// export default api;



import axios from "axios";
import { showError } from "../utils/toastHelper";

const api = axios.create({
  baseURL: "https://mahatransco.org/api",
  //  baseURL: "https://k3ndpxhp-9014.inc1.devtunnels.ms/api",
  //  baseURL: "http://10.202.100.90:9019/api/",//local
  timeout: 30000,
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("access");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => {
    // Handle success messages from backend (if any)
    const successMsg = response.data?.message || response.data?.detail;
    if (successMsg && typeof successMsg === "string") {
      // Optional: Uncomment if you want auto success toast for all APIs
      // showSuccess(successMsg);
    }
    return response;
  },

  (error) => {
    const status = error.response?.status;
    let errorMessage = "Something went wrong";

    if (status === 401) {
      localStorage.setItem("lastAuthError", "401");
      localStorage.clear();
      errorMessage = "Session expired. Please login again.";

      setTimeout(() => {
        window.location.href = "/";
      }, 800);
    } 
    else if (status === 400) {
      errorMessage = error.response?.data?.detail 
        || error.response?.data?.message 
        || error.response?.data?.error 
        || "Invalid request";
    } 
    else if (status === 403) {
      errorMessage = "You don't have permission to perform this action";
    } 
    else if (status === 404) {
      errorMessage = "Resource not found";
    } 
    else if (error.message === "Network Error") {
      errorMessage = "Network error. Please check your internet connection";
    }

    showError(errorMessage);

    return Promise.reject(error);
  }
);

export default api;